const SIGNALS_QUERY_KEY = 'signals';

export const signalsQueryKey = {
  signals: (companyDomain: string) => [SIGNALS_QUERY_KEY, companyDomain] as const,
};
